import {
  StorageUtility,
  StorageType,
  StorageUtilityOptions,
} from './storage.utility';

export class LocalStorageUtility extends StorageUtility {
  constructor(storageUtilityOptions?: StorageUtilityOptions) {
    super(StorageType.localStorage, storageUtilityOptions);
  }
}
